import {Fab, Icon, Tooltip} from "@mui/material";

import {useNIA} from "./NIAContext";

const NIALauncher = () => {
  const {openDrawer} = useNIA();

  return (
    <Tooltip title="Abrir NIA" placement="left" arrow>
      <Fab
        color="primary"
        variant="extended"
        onClick={openDrawer}
        sx={{
          boxShadow: "none",
          textTransform: "none",
          "&:hover": {
            boxShadow: "none",
          },
        }}
      >
        <Icon sx={{mr: 1}}>auto_awesome</Icon>
        NIA
      </Fab>
    </Tooltip>
  );
};

export default NIALauncher;
